import React from 'react';
import Container from "semantic-ui-react/dist/es/elements/Container/Container.js";
export var Component = function Component(props) {
  return React.createElement(Container, props);
};
Component.displayName = 'HorizontalGutters';